import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
const ThankYou = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0); // Ensure top scroll on page load
  }, []);



  return (
    <div className="flex flex-col items-center justify-center h-screen text-center">
  
       <div className="w-[400px] h-[300px]">
       <DotLottieReact
      src="https://lottie.host/334b83c2-c3d5-467a-87fa-92e8d3018908/dV91hDjTed.lottie"
      loop
      autoplay
    />
        </div>

      <h1 className="text-3xl font-bold text-green-600">
        Thank You for Your Purchase!
      </h1>
      <p className="text-lg text-gray-600 mt-2">
        Your order has been placed successfully.
      </p>
      <div className="flex flex-col sm:flex-row space-x-4">
        <Link to="/home">
          <button className="  px-6 py-2 bg-[#162c2a] text-white rounded-2xl flex items-center gap-2  transition mt-4">
            Start Shopping
            <span className="text-xl">→</span>
          </button>
        </Link>
        <Link to="/my-orders">
          <button className=" -ml-2 px-10 py-2 bg-[#162c2a] text-white rounded-2xl flex items-center gap-2  transition mt-4">
            My Order
            <span className="text-xl">→</span>
          </button>
        </Link>
      </div>
    </div>
  );
};

export default ThankYou;
